import React from "react";
import { Modal, Button } from "react-bootstrap";

const BookingSuccessModal = ({ show, onHide, booking }) => {
  return (
    <Modal show={show} centered size="sm">
      <Modal.Body className="booking-success-modal">
        <div className="text-center">
          {/* Icon */}
          <div className="booking-icon mb-3">
            <img
              src="assets/img/icons/tick-circle.svg"
              alt="Success Icon"
              className="img-fluid"
              style={{ margin: " 0 auto" }}
            />
          </div>

          {/* Title */}
          <h5 className="mb-3">Thanh toán thành công</h5>

          {/* Message */}
          <p>
            Đặt tour <strong>{booking.tourResponse.tourName}</strong> đã thành
            công với số tham chiếu{" "}
            <span className="text-primary">#{booking.bookingId}</span>
          </p>

          {/* Button */}
          <div className="d-flex align-items-center justify-content-center mt-4">
            <Button variant="primary" onClick={onHide}>
              Xem chi tiết đặt phòng
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BookingSuccessModal;
